import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { tr } from "@/utils/i18n";
import { MousePointer, ExternalLink, TrendingUp, LineChart } from "lucide-react";
import {
  LineChart as RechartsLine, Line, XAxis, YAxis,
  CartesianGrid, Tooltip, ResponsiveContainer
} from "recharts";

const CHART_TICK = { fill: '#71717a', fontSize: 12 };
const CHART_TOOLTIP = { backgroundColor: '#09090b', border: '1px solid #27272a', borderRadius: '8px' };
const CHART_LABEL = { color: '#fafafa' };
const CHART_DOT = { fill: '#06b6d4' };

export function AnalyticsTab({ affiliateStats, language, t }) {
  return (
    <div className="space-y-6" data-testid="analytics-content">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="bg-zinc-950/50 border-zinc-800">
          <CardContent className="p-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-cyan-500/20 flex items-center justify-center">
                <MousePointer className="w-6 h-6 text-cyan-400" />
              </div>
              <div>
                <p className="text-3xl font-bold text-white">{affiliateStats?.total_clicks || 0}</p>
                <p className="text-sm text-zinc-500">{t("totalClicks")}</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card className="bg-zinc-950/50 border-zinc-800">
          <CardContent className="p-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-violet-500/20 flex items-center justify-center">
                <ExternalLink className="w-6 h-6 text-violet-400" />
              </div>
              <div>
                <p className="text-3xl font-bold text-white">{(affiliateStats?.clicks_by_vendor?.summit || 0) + (affiliateStats?.clicks_by_vendor?.summit_flyer || 0)}</p>
                <p className="text-sm text-zinc-500">Summit Peptides {tr(language, 'Clicks', 'Cliques', 'Clics')}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <Card className="bg-zinc-950/50 border-zinc-800">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <TrendingUp className="w-5 h-5 text-cyan-400" />
            {tr(language, 'Affiliate Clicks (Last 30 Days)', 'Cliques de Afiliado (Últimos 30 Dias)', 'Clics de Afiliado (Últimos 30 Días)')}
          </CardTitle>
        </CardHeader>
        <CardContent>
          {affiliateStats?.clicks_by_day?.length > 0 ? (
            <ResponsiveContainer width="100%" height={300}>
              <RechartsLine data={affiliateStats.clicks_by_day}>
                <CartesianGrid strokeDasharray="3 3" stroke="#27272a" />
                <XAxis dataKey="date" stroke="#71717a" tick={CHART_TICK} />
                <YAxis stroke="#71717a" tick={CHART_TICK} />
                <Tooltip contentStyle={CHART_TOOLTIP} labelStyle={CHART_LABEL} />
                <Line type="monotone" dataKey="count" stroke="#06b6d4" strokeWidth={2} dot={CHART_DOT} />
              </RechartsLine>
            </ResponsiveContainer>
          ) : (
            <div className="flex flex-col items-center justify-center h-[300px] text-center">
              <LineChart className="w-16 h-16 text-zinc-700 mb-4" />
              <p className="text-zinc-400">{tr(language, 'No click data yet', 'Ainda sem dados de cliques', 'Aún no hay datos de clics')}</p>
              <p className="text-sm text-zinc-500">{tr(language, 'Share your links to track performance', 'Compartilhe seus links para acompanhar o desempenho', 'Comparte tus enlaces para seguir el rendimiento')}</p>
            </div>
          )}
        </CardContent>
      </Card>

      <Card className="bg-zinc-950/50 border-zinc-800">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-white">{tr(language, 'Your Referral Clicks', 'Seus Cliques de Indicação', 'Tus Clics de Referencia')}</h3>
              <p className="text-zinc-400 text-sm">{tr(language, "Clicks from cycles you've generated", 'Cliques dos ciclos que você gerou', 'Clics de los ciclos que generaste')}</p>
            </div>
            <div className="text-3xl font-bold text-cyan-400">{affiliateStats?.your_clicks || 0}</div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
